import appointments from "./appointments"
import auth from "./auth"
import dashboard from "./dashboard"
import notifications from "./notifications"

export default {
	auth,
	appointments,
	notifications,
	dashboard
}
